import { PatientSummaryService } from 'common/api';
import { serviceRequest } from 'utils/http';

export function getPatientSummaryAPI(referralId: string) {
  return serviceRequest(() =>
    PatientSummaryService.patientSummaryControllerGet(referralId)
  );
}
